import type { AckResult } from '@sw/protocol';
import { errorText } from '../i18n';
import { useUi } from '../stores/ui';

/** Muestra el error de un ack (si lo hay) y devuelve si fue correcto. */
export function handleAck(res: AckResult<unknown>): boolean {
  if (res.ok) return true;
  const params: Record<string, unknown> = { ...(res.error.params ?? {}) };
  if (typeof params.remainingMs === 'number') params.seconds = Math.ceil(params.remainingMs / 1000);
  useUi.getState().toast('error', errorText(res.error.code, params));
  return false;
}
